import { getSearchResults } from './api';

const { createAsyncThunk, createSlice } = require('@reduxjs/toolkit');

function createSearchInstanceSlice ({ instanceName, initialState }) {

	const baseReducerName = 'productSearchUgc';
	const instanceReducerName = instanceName.substr(0, 1).toUpperCase() + instanceName.substr(1);
	const reducerName = `${baseReducerName}_${instanceReducerName}`;
	const fetchSearchResults = createAsyncThunk(
		reducerName,
		async (apiParams) => {

			const response = await getSearchResults({ ...apiParams });
			return response;

		},
		{
			condition: (arg, { getState }) => {

				const { fetchStatus } = getState()[reducerName];
				if (fetchStatus === 'pending') {

					return false;

				}
				return true;

			}
		}
	);

	const slice = createSlice({
		name: reducerName,
		initialState,
		reducers: {
			emptySearchResults: (state) => {

				state.searchResults = null;
				state.fetchStatus = '';
				state.pageSize = 5;
				state.pageNumber = 1;
				state.previousPageNumber = 1;
				state.searchTerm = '';
				state.showMoreResultsFectchStatus = '';
				state.sortOrder = 1;
				state.totalResultsCount = 0;
				state.totalResultsLeft = 0;

			},
			newSearchResults: (state, action) => {

				state.fetchStatus = '';
				state.pageSize = 5;
				state.pageNumber = 1;
				state.previousPageNumber = 1;
				state.searchTerm = action.payload;
				state.showMoreResultsFectchStatus = '';
				state.sortOrder = 1;
				state.totalResultsCount = 0;
				state.totalResultsLeft = 0;

			},
			showMoreResults: (state) => {

				state.pageNumber += 1;
				state.pageSize = 10;

			}
		},
		extraReducers: {
			[fetchSearchResults.pending]: (state) => {

				if (state.previousPageNumber < state.pageNumber) {

					state.showMoreResultsFectchStatus = 'pending';

				} else {

					// normal search fetch status
					state.fetchStatus = 'pending';

				}

			},
			[fetchSearchResults.fulfilled]: (state, action) => {

				const { payload, meta } = action;
				const { pageNumber, results, totalRecords } = payload.result;
				const { searchTerm } = meta.arg;

				state.pageNumber = pageNumber;
				state.searchTerm = searchTerm;
				state.totalResultsCount = totalRecords;

				if (state.previousPageNumber < pageNumber) {

					state.previousPageNumber = pageNumber;
					state.searchResults.push(...results);
					state.showMoreResultsFectchStatus = 'fulfilled';

				} else {

					state.searchResults = results;
					state.fetchStatus = 'fulfilled';

				}

				state.totalResultsLeft = totalRecords - state.searchResults.length;

			},
			[fetchSearchResults.rejected]: (state) => {

				state.searchResults = [];
				state.fetchStatus = 'rejected';

			}
		}
	});

	return {
		reducer: slice.reducer,
		actions: slice.actions,
		fetchSearchResults
	};

}

export default createSearchInstanceSlice;
